/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import styles2 from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import Table from "components/Table/Table2.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import Pagination from "react-responsive-pagination";
import "bootstrap/dist/css/bootstrap.min.css";
import { CardFooter } from "reactstrap";
import TSSelect from "components/Forms/TSSelect";
import CardIcon from "components/Card/CardIcon.js";
import Icon from "@material-ui/core/Icon";
import AssignmentInd from "@material-ui/icons/AssignmentInd";
import CardFooter2 from "components/Card/CardFooter.js";
import Button from "components/CustomButtons/Button.js";
import Subject from "@material-ui/icons/Subject";
import { Collapse, Modal, ModalBody } from "reactstrap";
import axios from "utils/httpClient";

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: '"Sarabun", sans-serif',
    marginBottom: "3px",
    textDecoration: "none"
  }
};

const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);

export default function EditDashboard() {
  const classes = useStyles();
  const classes2 = useStyles2();

  const [l1OptionMain, setL1OptionMain] = useState([]);
  const [optionMain, setOptionMain] = useState("");
  const [option1, setOption1] = useState("");
  const [option2, setOption2] = useState("");
  const [option2B, setOption2B] = useState("");
  const [option3, setOption3] = useState("");
  const [option4, setOption4] = useState("");
  const [option3B, setOption3B] = useState("");
  const [option4B, setOption4B] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPage2, setCurrentPage2] = useState(1);
  const [tableHead, setTableHead] = useState([]);
  const [data, setData] = useState([]);
  const [tableHeadOther, setTableHeadOther] = useState([]);
  const [dataOther, setDataOther] = useState([]);
  const [selected, setSelected] = useState([]);
  const [select, setSelect] = useState([]);
  const [selected2, setSelected2] = useState([]);
  const [select2, setSelect2] = useState([]);
  const [l1Option, setL1Option] = useState([]);
  const [l2Option, setL2Option] = useState([]);
  const [l2OptionB, setL2OptionB] = useState([]);
  const [l3Option, setL3Option] = useState([]);
  const [l4Option, setL4Option] = useState([]);
  const [l3OptionB, setL3OptionB] = useState([]);
  const [l4OptionB, setL4OptionB] = useState([]);
  const [disable1, setDisable1] = useState(true);
  const [disable2, setDisable2] = useState(true);
  const [disable3, setDisable3] = useState(true);
  const [disable1B, setDisable1B] = useState(true);
  const [disable2B, setDisable2B] = useState(true);
  const [disable3B, setDisable3B] = useState(true);
  const [oldOption1, setOldOption1] = useState("");
  const [oldOption2, setOldOption2] = useState("");
  const [oldOption3, setOldOption3] = useState("");
  const [oldOption4, setOldOption4] = useState("");
  const [oldOption2B, setOldOption2B] = useState("");
  const [oldOption3B, setOldOption3B] = useState("");
  const [oldOption4B, setOldOption4B] = useState("");
  const [pageSize] = useState(10);
  const [year, setYear] = useState([]);
  const [modal, setModal] = useState(false);
  const [errMsg, setErrMsg] = useState([]);
  const [modalError, setModalError] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isOther, setIsOther] = useState(false);
  const [oldOptionMain, setOldOptionMain] = useState("");
  const [icon, setIcon] = useState("far fa-question-circle");

  const windowWidth = useWindowWidth();

  function useWindowWidth() {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth - 400);

    useEffect(() => {
      const resizeHandler = () => {
        setWindowWidth(window.innerWidth - 400);
      };

      window.addEventListener("resize", resizeHandler);
      return () => {
        window.removeEventListener("resize", resizeHandler);
      };
    }, []);

    return windowWidth;
  }

  const handleSubmit = evt => {
    evt.preventDefault();
    var cntErr = 0;

    var errMsg = [];

    if (cntErr > 0) {
      setErrMsg(errMsg);
      setModalError(true);
    } else {
      setModal(true);
    }
  };

  const handleToggle = evt => {
    setIsOther(!isOther);
  };

  const onSelected = e => {
    setSelected(e);
  };

  const onSelected2 = e => {
    setSelected2(e);
  };

  const isCheckMain = () => {
    if (optionMain !== oldOptionMain || option1 === 0) {
      return [{ value: "", label: "" }];
    }
  };

  const isCheck = () => {
    if (optionMain !== oldOptionMain) {
      return [{ value: "", label: "" }];
    }
  };

  const isCheck2 = () => {
    if (option2 !== oldOption2) {
      return [{ value: "", label: "" }];
    }
  };

  const isCheck3 = () => {
    if (option3 !== oldOption3) {
      return [{ value: "", label: "" }];
    }
  };

  const isCheck4 = () => {
    if (option1 !== oldOption1) {
      return [{ value: "", label: "" }];
    }
  };

  const isCheck2B = () => {
    if (option2B !== oldOption2B) {
      return [{ value: "", label: "" }];
    }
  };

  const isCheck3B = () => {
    if (option3B !== oldOption3B) {
      return [{ value: "", label: "" }];
    }
  };

  useEffect(() => {

    //   .then(response => response.json())
    //   .then(
    //     result => {
    //       setL1OptionMain(result.data);
    //       setL1Option(result.data);
    //     },
    //     error => {
    //       console.log(error);
    //     }
    //   );

      axios("/api/v1/group1")
      .then(
        result => {
          var res = result.data;
          setL1OptionMain(res.data);
          setL1Option(res.data);
        }, error => {console.log(error);}
      );  
    
  }, []);

  // useEffect(() => {
  //   setOldOptionMain(optionMain);
  //   if(optionMain !== oldOptionMain){
  //     setIsOpen(true);
  //     setOption2("");
  //     setOption3("");
  //     setDisable2(true);
  //     setDisable3(true);
  //     setL3Option([]);
  //     setData([]);
  //     setDataOther([]);
  //   }
  // }, [optionMain]);

  useEffect(() => {
    if (optionMain !== "") {

      //   .then(response => response.json())
      //   .then(
      //     result => {
      //       setL2OptionB(result.data);
      //       setDisable1B(false);
      //       setOldOptionMain(optionMain);
      //       if (optionMain !== oldOptionMain) {
      //         setOption2B("");
      //         setOption3B("");
      //         setDisable2(true);
      //         setDisable2B(true);
      //         setDisable3B(true);
      //         setL3OptionB([]);
      //         setData([]);
      //         if (oldOptionMain === "") {
      //           setIsOpen(true);
      //         } else {
      //           //setIsOpen(false);
      //           setOption1(0);
      //           setOption2(0);
      //           setOption3(0);
      //           setOption4(0);
      //           setData([]);
      //         }
      //         setDataOther([]);
      //       }
      //     },
      //     error => {
      //       console.log(error);
      //     }
      //   );

      axios("/api/v1/group2/" + optionMain)
      .then(
        result => {
          var res = result.data;
          setL2OptionB(res.data);
          setDisable1B(false);
          setOldOptionMain(optionMain);
          if (optionMain !== oldOptionMain) {
            setOption2B("");
            setOption3B("");
            setDisable2(true);
            setDisable2B(true);
            setDisable3B(true);
            setL3OptionB([]);
            setData([]);
            if (oldOptionMain === "") {
              setIsOpen(true);
            } else {
              setOption1(0);
              setOption2(0);
              setOption3(0);
              setOption4(0);
              setData([]);
            }
            setDataOther([]);
          }
        }, 
        error => {
          console.log(error);
        }
      );  
    }
  }, [optionMain]);

  useEffect(() => {
    if (option1 !== "") {

      //   .then(response => response.json())
      //   .then(
      //     result => {
      //       setL2Option(result.data);
      //       setDisable1(false);
      //       setOldOption1(option1);
      //       if (option1 !== oldOption1) {
      //         setOption2("");
      //         setOption3("");
      //         setDisable2(true);
      //         setDisable3(true);
      //         setL3Option([]);
      //         setData([]);
      //       }
      //     },
      //     error => {
      //       console.log(error);
      //     }
      //   );

      axios("/api/v1/group2/" + option1)
      .then(
        result => {
          var res = result.data;
          setL2Option(res.data);
          setDisable1(false);
          setOldOption1(option1);
          if (option1 !== oldOption1) {
            setOption2("");
            setOption3("");
            setDisable2(true);
            setDisable3(true);
            setL3Option([]);
            setData([]);
          }
        }, 
        error => {
          console.log(error);
        }
      );  
    }
  }, [option1]);

  useEffect(() => {
    if (option1 === 1 || option1 === 4) {
      if (option2 !== "") {
        axios("/api/v1/subGroup3/" + option2)
          .then(response => response.data)
          .then(
            result => {
              setL3Option(result.data);
              setDisable2(false);
              setOldOption2(option2);
              if (option2 !== oldOption2) {
                setDisable3(true);
                setOption3("");
                setData([]);
              }
            },
            error => {
              console.log(error);
            }
          );
      }
    } else {
      setOldOption2(option2);
    }
  }, [option2]);

  useEffect(() => {
    if (optionMain === 1 || optionMain === 4) {
      if (option2B !== "") {
        axios("/api/v1/subGroup3/" + option2B)
          .then(response => response.data)
          .then(
            result => {
              setL3OptionB(result.data);
              setDisable2B(false);
              setOldOption2B(option2B);
              if (option2B !== oldOption2B) {
                setDisable3B(true);
                setOption3B("");
                setData([]);
              }
            },
            error => {
              console.log(error);
            }
          );
      }
    } else {
      setOldOption2B(option2B);
    }
  }, [option2B]);

  useEffect(() => {
    if (option1 === 4) {
      if (option3 !== "") {
        axios("/api/v1/subGroup4/" + option3)
          .then(response => response.data)
          .then(
            result => {
              setL4Option(result.data);
              setDisable3(false);
              setOldOption3(option3);
              if (option3 !== oldOption3) {
                setOption4("");
                setData([]);
              }
            },
            error => {
              console.log(error);
            }
          );
      }
    }
  }, [option3]);

  useEffect(() => {
    if (optionMain === 4) {
      if (option3B !== "") {
        axios("/api/v1/subGroup4/" + option3B)
          .then(response => response.data)
          .then(
            result => {
              setL4OptionB(result.data);
              setDisable3B(false);
              setOldOption3B(option3B);
              if (option3B !== oldOption3B) {
                setOption4B("");
                setData([]);
              }
            },
            error => {
              console.log(error);
            }
          );
      }
    }
  }, [option3B]);

  useEffect(() => {
    setOldOption4(option4);
  }, [option4]);

  useEffect(() => {
    setOldOption4B(option4B);
  }, [option4B]);

  useEffect(() => {
    if (option1 !== 1 && option1 !== 4) {
      // if (option2 !== "") {
      if (option2 !== oldOption2) {
        setCurrentPage(1);
      }

      axios(
        "/api/v1/tableSave/" +
          option2 +
          "/pagination?PageNumber=" +
          currentPage +
          "&PageSize=" +
          pageSize
      )
        .then(response => response.data)
        .then(
          result => {
            //setData(result.data);
            if (option2B !== "" && option2B !== oldOption2B) {
              setIsOpen(true);
              setOption1(0);
            }
            var tableList = [];
            if (result.data.length > 0) {
              // if (result.data[0].listData[0].key !== 0) {
              result.data.forEach(e => {
                if (e.listData.length < 6) {
                  var l1 = [];
                  var name;
                  var target;
                  var dataId;
                  var tags;
                  var j = 0;
                  for (var i = 0; i < 6; i++) {
                    if (
                      e.listData[j] !== undefined &&
                      e.listData[j].key.toString() === year[i].value
                    ) {
                      if (e.showId === 1) {
                        l1 = l1.concat(
                          e.listData[j].value2 === null
                            ? 0
                            : e.listData[j].value2.toFixed(2)
                        );
                      } else if (e.showId === 2) {
                        l1 = l1.concat(e.listData[j].value);
                      }
                      name = e.name;
                      target =
                        e.typeName + " " + Number(e.target).toLocaleString();
                      dataId = e.dataId;
                      tags = e.tags;
                      j++;
                    } else {
                      l1 = l1.concat(0);
                      name = e.name;
                      target =
                        e.typeName + " " + Number(e.target).toLocaleString();
                      tags = e.tags;
                    }
                  }

                  tableList.push([
                    name,
                    target,
                    l1[5].toLocaleString(),
                    l1[4].toLocaleString(),
                    l1[3].toLocaleString(),
                    l1[2].toLocaleString(),
                    l1[1].toLocaleString(),
                    l1[0].toLocaleString(),
                    (dataId = e.listData[0].dataId),
                    option1,
                    option2,
                    tags
                  ]);
                } else {
                  if (e.showId === 1 || e.showId === 3) {
                    tableList.push([
                      e.name,
                      e.typeName + " " + Number(e.target).toLocaleString(),
                      e.listData[5] === undefined
                        ? 0
                        : e.listData[5].value2.toFixed(2).toLocaleString(),
                      e.listData[4] === undefined
                        ? 0
                        : e.listData[4].value2.toFixed(2).toLocaleString(),
                      e.listData[3] === undefined
                        ? 0
                        : e.listData[3].value2.toFixed(2).toLocaleString(),
                      e.listData[2] === undefined
                        ? 0
                        : e.listData[2].value2.toFixed(2).toLocaleString(),
                      e.listData[1] === undefined
                        ? 0
                        : e.listData[1].value2.toFixed(2).toLocaleString(),
                      e.listData[0] === undefined
                        ? 0
                        : e.listData[0].value2.toFixed(2).toLocaleString(),
                      e.dataId,
                      option1,
                      option2,
                      e.tags
                    ]);
                  } else if (e.showId === 2 || e.showId === 4) {
                    tableList.push([
                      e.name,
                      e.typeName + " " + Number(e.target).toLocaleString(),
                      e.listData[5] === undefined
                        ? 0
                        : e.listData[5].value.toLocaleString(),
                      e.listData[4] === undefined
                        ? 0
                        : e.listData[4].value.toLocaleString(),
                      e.listData[3] === undefined
                        ? 0
                        : e.listData[3].value.toLocaleString(),
                      e.listData[2] === undefined
                        ? 0
                        : e.listData[2].value.toLocaleString(),
                      e.listData[1] === undefined
                        ? 0
                        : e.listData[1].value.toLocaleString(),
                      e.listData[0] === undefined
                        ? 0
                        : e.listData[0].value.toLocaleString(),
                      e.dataId,
                      option1,
                      option2,
                      e.tags
                    ]);
                  }
                }
              });
              // } else {
              //   tableList.push([
              //     result.data[0].name,
              //     result.data[0].typeName + " " + result.data[0].target,
              //     0,
              //     0,
              //     0,
              //     0,
              //     0,
              //     0,
              //     result.data[0].dataId,
              //     option1,
              //     option2,
              //     result.data[0].tags
              //   ]);
              // }
            }

            axios(
              "/api/v1/checkReport?group1=" +
                optionMain +
                "&group2=" +
                option2B +
                "&group3=" +
                option3B +
                "&group4=" +
                option4B,
              {
                method: "GET"
              }
            )
              .then(response => response.data)
              .then(
                result => {
                  var list = [];
                  if (
                    result.data.reportSub !== null &&
                    result.data.reportSub.length > 0 &&
                    !result.data.isOther
                  ) {
                    result.data.reportSub.forEach(e => {
                      list.push([e.dataId]);
                    });
                    setSelect(result.data.reportSub);
                  } else if (selected.length > 0) {
                    setSelect(selected);
                  } else {
                    setSelect([]);
                  }
                },
                error => {
                  console.log(error);
                }
              );

            setData(tableList);
            var total = result.total / pageSize;
            if (!Number.isInteger(total)) {
              setTotalPages((total | 0) + 1);
            } else if (total === 0) {
              setTotalPages(1);
            } else {
              setTotalPages(total);
            }
          },
          error => {
            console.log(error);
          }
        );
    }
    // }
  }, [option2, currentPage]);

  useEffect(() => {
    if (option1 === 1) {
      if (option3 !== "") {
        if (option3 !== oldOption3) {
          setCurrentPage(1);
        }
        axios(
          "/api/v1/table2Save/" +
            option3 +
            "/pagination?PageNumber=" +
            currentPage +
            "&PageSize=" +
            pageSize
        )
          .then(response => response.data)
          .then(
            result => {
              //setData(result.data);
              setIsOpen(true);
              var tableList = [];
              if (result.data.length > 0) {
                // if (result.data[0].listData[0].key !== 0) {
                result.data.forEach(e => {
                  if (e.listData.length < 6) {
                    var l1 = [];
                    var name;
                    var target;
                    var dataId;
                    var tags;
                    var j = 0;
                    for (var i = 0; i < 6; i++) {
                      if (
                        e.listData[j] !== undefined &&
                        e.listData[j].key.toString() === year[i].value
                      ) {
                        if (e.showId === 1) {
                          l1 = l1.concat(
                            e.listData[j].value2 === null
                              ? 0
                              : e.listData[j].value2.toFixed(2)
                          );
                        } else if (e.showId === 2) {
                          l1 = l1.concat(e.listData[j].value);
                        }
                        name = e.name;
                        target =
                          e.typeName + " " + Number(e.target).toLocaleString();
                        tags = e.tags;
                        dataId = e.dataId;
                        j++;
                      } else {
                        l1 = l1.concat(0);
                        name = e.name;
                        target =
                          e.typeName + " " + Number(e.target).toLocaleString();
                        tags = e.tags;
                      }
                    }

                    tableList.push([
                      name,
                      target,
                      l1[5].toLocaleString(),
                      l1[4].toLocaleString(),
                      l1[3].toLocaleString(),
                      l1[2].toLocaleString(),
                      l1[1].toLocaleString(),
                      l1[0].toLocaleString(),
                      (dataId = e.listData[0].dataId),
                      option1,
                      option2,
                      option3,
                      tags
                    ]);
                  } else {
                    if (e.showId === 1 || e.showId === 3) {
                      tableList.push([
                        e.name,
                        e.typeName + " " + Number(e.target).toLocaleString(),
                        e.listData[5] === undefined
                          ? 0
                          : e.listData[5].value2.toFixed(2).toLocaleString(),
                        e.listData[4] === undefined
                          ? 0
                          : e.listData[4].value2.toFixed(2).toLocaleString(),
                        e.listData[3] === undefined
                          ? 0
                          : e.listData[3].value2.toFixed(2).toLocaleString(),
                        e.listData[2] === undefined
                          ? 0
                          : e.listData[2].value2.toFixed(2).toLocaleString(),
                        e.listData[1] === undefined
                          ? 0
                          : e.listData[1].value2.toFixed(2).toLocaleString(),
                        e.listData[0] === undefined
                          ? 0
                          : e.listData[0].value2.toFixed(2).toLocaleString(),
                        e.dataId,
                        option1,
                        option2,
                        option3,
                        e.tags
                      ]);
                    } else if (e.showId === 2 || e.showId === 4) {
                      tableList.push([
                        e.name,
                        e.typeName + " " + Number(e.target).toLocaleString(),
                        e.listData[5] === undefined
                          ? 0
                          : e.listData[5].value.toLocaleString(),
                        e.listData[4] === undefined
                          ? 0
                          : e.listData[4].value.toLocaleString(),
                        e.listData[3] === undefined
                          ? 0
                          : e.listData[3].value.toLocaleString(),
                        e.listData[2] === undefined
                          ? 0
                          : e.listData[2].value.toLocaleString(),
                        e.listData[1] === undefined
                          ? 0
                          : e.listData[1].value.toLocaleString(),
                        e.listData[0] === undefined
                          ? 0
                          : e.listData[0].value.toLocaleString(),
                        e.dataId,
                        option1,
                        option2,
                        option3,
                        e.tags
                      ]);
                    }
                  }
                });
                // } else {
                //   tableList.push([
                //     result.data[0].name,
                //     result.data[0].typeName + " " + result.data[0].target,
                //     0,
                //     0,
                //     0,
                //     0,
                //     0,
                //     0,
                //     result.data[0].dataId,
                //     option1,
                //     option2,
                //     option3,
                //     result.data[0].tags
                //   ]);
                // }
              }

              axios(
                "/api/v1/checkReport?group1=" +
                  optionMain +
                  "&group2=" +
                  option2B +
                  "&group3=" +
                  option3B +
                  "&group4=" +
                  option4B,
                {
                  method: "GET"
                }
              )
                .then(response => response.data)
                .then(
                  result => {
                    var list = [];
                    if (
                      result.data.reportSub !== null &&
                      result.data.reportSub.length > 0 &&
                      !result.data.isOther
                    ) {
                      result.data.reportSub.forEach(e => {
                        list.push([e.dataId]);
                      });
                      setSelect(result.data.reportSub);
                    } else if (selected.length > 0) {
                      setSelect(selected);
                    } else {
                      setSelect([]);
                    }
                  },
                  error => {
                    console.log(error);
                  }
                );

              setData(tableList);
              var total = result.total / pageSize;
              if (!Number.isInteger(total)) {
                setTotalPages((total | 0) + 1);
              } else if (total === 0) {
                setTotalPages(1);
              } else {
                setTotalPages(total);
              }
            },
            error => {
              console.log(error);
            }
          );
      }
    }
  }, [option3, currentPage]);

  useEffect(() => {
    if (isOther) {
      axios(
        "/api/v1/tableOther/" +
          "/pagination?PageNumber=" +
          currentPage2 +
          "&PageSize=" +
          pageSize
      )
        .then(response => response.data)
        .then(
          result => {
            //setData(result.data);
            var tableList = [];
            if (result.data.length > 0) {
              var name;
              result.data.forEach(e => {
                name = e.name;
                var dataId = e.dataOId;
                tableList.push([name, dataId]);
              });
            }

            axios(
              "/api/v1/checkReport?group1=" +
                optionMain +
                "&group2=" +
                option2B +
                "&group3=" +
                option3B +
                "&group4=" +
                option4B +
                "&isOther=" +
                true,
              {
                method: "GET"
              }
            )
              .then(response => response.data)
              .then(
                result => {
                  var list = [];
                  if (
                    result.data.reportSub !== null &&
                    result.data.reportSub.length > 0 &&
                    result.data.isOther
                  ) {
                    result.data.reportSub.forEach(e => {
                      list.push([e.dataId]);
                    });
                    setSelect2(result.data.reportSub);
                  } else if (selected.length > 0) {
                    setSelect(selected);
                  } else {
                    setSelect([]);
                  }
                },
                error => {
                  console.log(error);
                }
              );

            setDataOther(tableList);
            var total = result.total / pageSize;
            if (!Number.isInteger(total)) {
              setTotalPages((total | 0) + 1);
            } else if (total === 0) {
              setTotalPages(1);
            } else {
              setTotalPages(total);
            }
          },
          error => {
            console.log(error);
          }
        );
    }
  }, [optionMain, isOther, option2B, option3B, option4B, currentPage2]);

  useEffect(() => {
    if (option1 === 4) {
      if (option4 !== "") {
        if (option4 !== oldOption4) {
          setCurrentPage(1);
        }
        axios(
          "/api/v1/table3Save/" +
            option4 +
            "/pagination?PageNumber=" +
            currentPage +
            "&PageSize=" +
            pageSize
        )
          .then(response => response.data)
          .then(
            result => {
              //setData(result.data);
              setIsOpen(true);
              var tableList = [];
              if (result.data.length > 0) {
                // if (result.data[0].listData[0].key !== 0) {
                result.data.forEach(e => {
                  if (e.listData.length < 6) {
                    var l1 = [];
                    var name;
                    var target;
                    var dataId;
                    var tags;
                    var j = 0;
                    for (var i = 0; i < 6; i++) {
                      if (
                        e.listData[j] !== undefined &&
                        e.listData[j].key.toString() === year[i].value
                      ) {
                        if (e.showId === 1) {
                          l1 = l1.concat(
                            e.listData[j].value2 === null
                              ? 0
                              : e.listData[j].value2.toFixed(2)
                          );
                        } else if (e.showId === 2) {
                          l1 = l1.concat(e.listData[j].value);
                        }
                        name = e.name;
                        target =
                          e.typeName + " " + Number(e.target).toLocaleString();
                        tags = e.tags;
                        dataId = e.dataId;
                        j++;
                      } else {
                        l1 = l1.concat(0);
                        name = e.name;
                        target =
                          e.typeName + " " + Number(e.target).toLocaleString();
                        tags = e.tags;
                      }
                    }

                    tableList.push([
                      name,
                      target,
                      l1[5].toLocaleString(),
                      l1[4].toLocaleString(),
                      l1[3].toLocaleString(),
                      l1[2].toLocaleString(),
                      l1[1].toLocaleString(),
                      l1[0].toLocaleString(),
                      (dataId = e.listData[0].dataId),
                      option1,
                      option2,
                      option3,
                      option4,
                      tags
                    ]);
                  } else {
                    if (e.showId === 1 || e.showId === 3) {
                      tableList.push([
                        e.name,
                        e.typeName + " " + Number(e.target).toLocaleString(),
                        e.listData[5] === undefined
                          ? 0
                          : e.listData[5].value2.toFixed(2).toLocaleString(),
                        e.listData[4] === undefined
                          ? 0
                          : e.listData[4].value2.toFixed(2).toLocaleString(),
                        e.listData[3] === undefined
                          ? 0
                          : e.listData[3].value2.toFixed(2).toLocaleString(),
                        e.listData[2] === undefined
                          ? 0
                          : e.listData[2].value2.toFixed(2).toLocaleString(),
                        e.listData[1] === undefined
                          ? 0
                          : e.listData[1].value2.toFixed(2).toLocaleString(),
                        e.listData[0] === undefined
                          ? 0
                          : e.listData[0].value2.toFixed(2).toLocaleString(),
                        e.dataId,
                        option1,
                        option2,
                        option3,
                        option4,
                        e.tags
                      ]);
                    } else if (e.showId === 2 || e.showId === 4) {
                      tableList.push([
                        e.name,
                        e.typeName + " " + Number(e.target).toLocaleString(),
                        e.listData[5] === undefined
                          ? 0
                          : e.listData[5].value.toLocaleString(),
                        e.listData[4] === undefined
                          ? 0
                          : e.listData[4].value.toLocaleString(),
                        e.listData[3] === undefined
                          ? 0
                          : e.listData[3].value.toLocaleString(),
                        e.listData[2] === undefined
                          ? 0
                          : e.listData[2].value.toLocaleString(),
                        e.listData[1] === undefined
                          ? 0
                          : e.listData[1].value.toLocaleString(),
                        e.listData[0] === undefined
                          ? 0
                          : e.listData[0].value.toLocaleString(),
                        e.dataId,
                        option1,
                        option2,
                        option3,
                        option4,
                        e.tags
                      ]);
                    }
                  }
                });
                // } else {
                //   tableList.push([
                //     result.data[0].name,
                //     result.data[0].typeName + " " + result.data[0].target,
                //     0,
                //     0,
                //     0,
                //     0,
                //     0,
                //     0,
                //     result.data[0].dataId,
                //     option1,
                //     option2,
                //     option3,
                //     option4,
                //     result.data[0].tags
                //   ]);
                // }
              }

              axios(
                "/api/v1/checkReport?group1=" +
                  optionMain +
                  "&group2=" +
                  option2B +
                  "&group3=" +
                  option3B +
                  "&group4=" +
                  option4B,
                {
                  method: "GET"
                }
              )
                .then(response => response.data)
                .then(
                  result => {
                    var list = [];
                    if (
                      result.data.reportSub !== null &&
                      result.data.reportSub.length > 0 &&
                      !result.data.isOther
                    ) {
                      result.data.reportSub.forEach(e => {
                        list.push([e.dataId]);
                      });
                      setSelect(result.data.reportSub);
                    } else if (selected.length > 0) {
                      setSelect(selected);
                    } else {
                      setSelect([]);
                    }
                  },
                  error => {
                    console.log(error);
                  }
                );

              setData(tableList);
              var total = result.total / pageSize;
              if (!Number.isInteger(total)) {
                setTotalPages((total | 0) + 1);
              } else if (total === 0) {
                setTotalPages(1);
              } else {
                setTotalPages(total);
              }
            },
            error => {
              console.log(error);
            }
          );
      }
    }
  }, [option4, currentPage]);

  useEffect(() => {
    axios("/api/v1/year/")
      .then(response => response.data)
      .then(
        result => {
          tableHead.push(
            "",
            "ชื่อตัวชี้วัด",
            "ค่าเป้าหมาย",
            result[5].label,
            result[4].label,
            result[3].label,
            result[2].label,
            result[1].label,
            result[0].label
          );
          setYear(result);
        },
        error => {
          console.log(error);
        }
      );

    tableHeadOther.push("", "ชื่อข้อมูล");
  }, []);

  const handleConfirm = evt => {
    evt.preventDefault();
    setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json"
      },
      data: {
        selected: isOther ? selected2 : selected,
        option1: option1 === "" ? null : option1,
        option2: option2 === "" ? null : option2,
        option3: option3 === "" ? null : option3,
        option4: option4 === "" ? null : option4,
        option1Save: optionMain === "" ? null : optionMain,
        option2Save: option2B === "" ? null : option2B,
        option3Save: option3B === "" ? null : option3B,
        option4Save: option4B === "" ? null : option4B,
        isOther: isOther
      }
    };

    axios("/api/v1/data/select", requestOptions)
      .then(response => response.data)
      .then(
        result => {
          setModal(false);
          setIcon("far fa-question-circle");
          if (option2 !== "" && option3 === "") {
            axios(
              "/api/v1/tableSave/" +
                option2 +
                "/pagination?PageNumber=" +
                currentPage +
                "&PageSize=" +
                pageSize
            )
              .then(response => response.data)
              .then(
                result => {
                  //setData(result.data);
                  setIsOpen(true);
                  var tableList = [];
                  if (result.data.length > 0) {
                    if (result.data[0].listData[0].key !== 0) {
                      result.data.forEach(e => {
                        if (e.listData.length < 6) {
                          var l1 = [];
                          var name;
                          var target;
                          var dataId;
                          var tags;
                          var j = 0;
                          for (var i = 0; i < 6; i++) {
                            if (
                              e.listData[j] !== undefined &&
                              e.listData[j].key.toString() === year[i].value
                            ) {
                              if (e.showId === 1) {
                                l1 = l1.concat(
                                  e.listData[j].value2 === null
                                    ? 0
                                    : e.listData[j].value2.toFixed(2)
                                );
                              } else if (e.showId === 2) {
                                l1 = l1.concat(e.listData[j].value);
                              }
                              name = e.name;
                              target =
                                e.typeName +
                                " " +
                                Number(e.target).toLocaleString();
                              dataId = e.dataId;
                              tags = e.tags;
                              j++;
                            } else {
                              l1 = l1.concat(0);
                              name = e.name;
                              target =
                                e.typeName +
                                " " +
                                Number(e.target).toLocaleString();
                              tags = e.tags;
                            }
                          }

                          tableList.push([
                            name,
                            target,
                            l1[5].toLocaleString(),
                            l1[4].toLocaleString(),
                            l1[3].toLocaleString(),
                            l1[2].toLocaleString(),
                            l1[1].toLocaleString(),
                            l1[0].toLocaleString(),
                            (dataId = e.listData[0].dataId),
                            option1,
                            option2,
                            tags
                          ]);
                        } else {
                          if (e.showId === 1 || e.showId === 3) {
                            tableList.push([
                              e.name,
                              e.typeName +
                                " " +
                                Number(e.target).toLocaleString(),
                              e.listData[5] === undefined
                                ? 0
                                : e.listData[5].value2
                                    .toFixed(2)
                                    .toLocaleString(),
                              e.listData[4] === undefined
                                ? 0
                                : e.listData[4].value2
                                    .toFixed(2)
                                    .toLocaleString(),
                              e.listData[3] === undefined
                                ? 0
                                : e.listData[3].value2
                                    .toFixed(2)
                                    .toLocaleString(),
                              e.listData[2] === undefined
                                ? 0
                                : e.listData[2].value2
                                    .toFixed(2)
                                    .toLocaleString(),
                              e.listData[1] === undefined
                                ? 0
                                : e.listData[1].value2
                                    .toFixed(2)
                                    .toLocaleString(),
                              e.listData[0] === undefined
                                ? 0
                                : e.listData[0].value2
                                    .toFixed(2)
                                    .toLocaleString(),
                              e.dataId,
                              option1,
                              option2,
                              e.tags
                            ]);
                          } else if (e.showId === 2 || e.showId === 4) {
                            tableList.push([
                              e.name,
                              e.typeName +
                                " " +
                                Number(e.target).toLocaleString(),
                              e.listData[5] === undefined
                                ? 0
                                : e.listData[5].value.toLocaleString(),
                              e.listData[4] === undefined
                                ? 0
                                : e.listData[4].value.toLocaleString(),
                              e.listData[3] === undefined
                                ? 0
                                : e.listData[3].value.toLocaleString(),
                              e.listData[2] === undefined
                                ? 0
                                : e.listData[2].value.toLocaleString(),
                              e.listData[1] === undefined
                                ? 0
                                : e.listData[1].value.toLocaleString(),
                              e.listData[0] === undefined
                                ? 0
                                : e.listData[0].value.toLocaleString(),
                              e.dataId,
                              option1,
                              option2,
                              e.tags
                            ]);
                          }
                        }
                      });
                    } else {
                      tableList.push([
                        result.data[0].name,
                        result.data[0].typeName + " " + result.data[0].target,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        result.data[0].dataId,
                        option1,
                        option2,
                        result.data[0].tags
                      ]);
                    }
                  }

                  axios(
                    "/api/v1/checkReport?group1=" +
                      option1 +
                      "&group2=" +
                      option2 +
                      "&group3=" +
                      option3 +
                      "&group4=" +
                      option4,
                    {
                      method: "GET"
                    }
                  )
                    .then(response => response.data)
                    .then(
                      result => {
                        var list = [];
                        if (
                          result.data.reportSub !== null &&
                          result.data.reportSub.length > 0
                        ) {
                          result.data.reportSub.forEach(e => {
                            list.push([e.dataId]);
                          });
                          setSelect(result.data.reportSub);
                        }
                      },
                      error => {
                        console.log(error);
                      }
                    );

                  setData(tableList);
                  var total = result.total / pageSize;
                  if (!Number.isInteger(total)) {
                    setTotalPages((total | 0) + 1);
                  } else if (total === 0) {
                    setTotalPages(1);
                  } else {
                    setTotalPages(total);
                  }
                },
                error => {
                  console.log(error);
                }
              );
          } else if (option3 !== "" && option4 === "") {
            axios(
              "/api/v1/table2Save/" +
                option3 +
                "/pagination?PageNumber=" +
                currentPage +
                "&PageSize=" +
                pageSize
            )
              .then(response => response.data)
              .then(
                result => {
                  //setData(result.data);
                  setIsOpen(true);
                  var tableList = [];
                  if (result.data.length > 0) {
                    if (result.data[0].listData[0].key !== 0) {
                      result.data.forEach(e => {
                        if (e.listData.length < 6) {
                          var l1 = [];
                          var name;
                          var target;
                          var dataId;
                          var tags;
                          var j = 0;
                          for (var i = 0; i < 6; i++) {
                            if (
                              e.listData[j] !== undefined &&
                              e.listData[j].key.toString() === year[i].value
                            ) {
                              if (e.showId === 1) {
                                l1 = l1.concat(
                                  e.listData[j].value2 === null
                                    ? 0
                                    : e.listData[j].value2.toFixed(2)
                                );
                              } else if (e.showId === 2) {
                                l1 = l1.concat(e.listData[j].value);
                              }
                              name = e.name;
                              target =
                                e.typeName +
                                " " +
                                Number(e.target).toLocaleString();
                              dataId = e.dataId;
                              j++;
                            } else {
                              l1 = l1.concat(0);
                              name = e.name;
                              target =
                                e.typeName +
                                " " +
                                Number(e.target).toLocaleString();
                              tags = e.tags;
                            }
                          }

                          tableList.push([
                            name,
                            target,
                            l1[5].toLocaleString(),
                            l1[4].toLocaleString(),
                            l1[3].toLocaleString(),
                            l1[2].toLocaleString(),
                            l1[1].toLocaleString(),
                            l1[0].toLocaleString(),
                            (dataId = e.listData[0].dataId),
                            option1,
                            option2,
                            option3
                          ]);
                        } else {
                          if (e.showId === 1 || e.showId === 3) {
                            tableList.push([
                              e.name,
                              e.typeName +
                                " " +
                                Number(e.target).toLocaleString(),
                              e.listData[5] === undefined
                                ? 0
                                : e.listData[5].value2
                                    .toFixed(2)
                                    .toLocaleString(),
                              e.listData[4] === undefined
                                ? 0
                                : e.listData[4].value2
                                    .toFixed(2)
                                    .toLocaleString(),
                              e.listData[3] === undefined
                                ? 0
                                : e.listData[3].value2
                                    .toFixed(2)
                                    .toLocaleString(),
                              e.listData[2] === undefined
                                ? 0
                                : e.listData[2].value2
                                    .toFixed(2)
                                    .toLocaleString(),
                              e.listData[1] === undefined
                                ? 0
                                : e.listData[1].value2
                                    .toFixed(2)
                                    .toLocaleString(),
                              e.listData[0] === undefined
                                ? 0
                                : e.listData[0].value2
                                    .toFixed(2)
                                    .toLocaleString(),
                              e.dataId,
                              option1,
                              option2,
                              option3
                            ]);
                          } else if (e.showId === 2 || e.showId === 4) {
                            tableList.push([
                              e.name,
                              e.typeName +
                                " " +
                                Number(e.target).toLocaleString(),
                              e.listData[5] === undefined
                                ? 0
                                : e.listData[5].value.toLocaleString(),
                              e.listData[4] === undefined
                                ? 0
                                : e.listData[4].value.toLocaleString(),
                              e.listData[3] === undefined
                                ? 0
                                : e.listData[3].value.toLocaleString(),
                              e.listData[2] === undefined
                                ? 0
                                : e.listData[2].value.toLocaleString(),
                              e.listData[1] === undefined
                                ? 0
                                : e.listData[1].value.toLocaleString(),
                              e.listData[0] === undefined
                                ? 0
                                : e.listData[0].value.toLocaleString(),
                              e.dataId,
                              option1,
                              option2,
                              option3
                            ]);
                          }
                        }
                      });
                    } else {
                      tableList.push([
                        result.data[0].name,
                        result.data[0].typeName + " " + result.data[0].target,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        result.data[0].dataId,
                        option1,
                        option2,
                        option3
                      ]);
                    }
                  }

                  axios(
                    "/api/v1/checkReport?group1=" +
                      option1 +
                      "&group2=" +
                      option2 +
                      "&group3=" +
                      option3 +
                      "&group4=" +
                      option4,
                    {
                      method: "GET"
                    }
                  )
                    .then(response => response.data)
                    .then(
                      result => {
                        var list = [];
                        if (
                          result.data.reportSub !== null &&
                          result.data.reportSub.length > 0
                        ) {
                          result.data.reportSub.forEach(e => {
                            list.push([e.dataId]);
                          });
                          setSelect(result.data.reportSub);
                        }
                      },
                      error => {
                        console.log(error);
                      }
                    );

                  setData(tableList);
                  var total = result.total / pageSize;
                  if (!Number.isInteger(total)) {
                    setTotalPages((total | 0) + 1);
                  } else if (total === 0) {
                    setTotalPages(1);
                  } else {
                    setTotalPages(total);
                  }
                },
                error => {
                  console.log(error);
                }
              );
          } else if (option4 !== "") {
            axios(
              "/api/v1/table3Save/" +
                option4 +
                "/pagination?PageNumber=" +
                currentPage +
                "&PageSize=" +
                pageSize
            )
              .then(response => response.data)
              .then(
                result => {
                  //setData(result.data)
                  setIsOpen(true);
                  var tableList = [];
                  if (result.data.length > 0) {
                    if (result.data[0].listData[0].key !== 0) {
                      result.data.forEach(e => {
                        if (e.listData.length < 6) {
                          var l1 = [];
                          var name;
                          var target;
                          var dataId;
                          var tags;
                          var j = 0;
                          for (var i = 0; i < 6; i++) {
                            if (
                              e.listData[j] !== undefined &&
                              e.listData[j].key.toString() === year[i].value
                            ) {
                              if (e.showId === 1) {
                                l1 = l1.concat(e.listData[j].value2.toFixed(2));
                              } else if (e.showId === 2) {
                                l1 = l1.concat(e.listData[j].value);
                              }
                              name = e.name;
                              target =
                                e.typeName +
                                " " +
                                Number(e.target).toLocaleString();
                              dataId = e.dataId;
                              j++;
                            } else {
                              l1 = l1.concat(0);
                              name = e.name;
                              target =
                                e.typeName +
                                " " +
                                Number(e.target).toLocaleString();
                              tags = e.tags;
                            }
                          }

                          tableList.push([
                            name,
                            target,
                            l1[5].toLocaleString(),
                            l1[4].toLocaleString(),
                            l1[3].toLocaleString(),
                            l1[2].toLocaleString(),
                            l1[1].toLocaleString(),
                            l1[0].toLocaleString(),
                            (dataId = e.listData[0].dataId),
                            option1,
                            option2,
                            option3,
                            option4
                          ]);
                        } else {
                          if (e.showId === 1 || e.showId === 3) {
                            tableList.push([
                              e.name,
                              e.typeName +
                                " " +
                                Number(e.target).toLocaleString(),
                              e.listData[5] === undefined
                                ? 0
                                : e.listData[5].value2
                                    .toFixed(2)
                                    .toLocaleString(),
                              e.listData[4] === undefined
                                ? 0
                                : e.listData[4].value2
                                    .toFixed(2)
                                    .toLocaleString(),
                              e.listData[3] === undefined
                                ? 0
                                : e.listData[3].value2
                                    .toFixed(2)
                                    .toLocaleString(),
                              e.listData[2] === undefined
                                ? 0
                                : e.listData[2].value2
                                    .toFixed(2)
                                    .toLocaleString(),
                              e.listData[1] === undefined
                                ? 0
                                : e.listData[1].value2
                                    .toFixed(2)
                                    .toLocaleString(),
                              e.listData[0] === undefined
                                ? 0
                                : e.listData[0].value2
                                    .toFixed(2)
                                    .toLocaleString(),
                              e.dataId,
                              option1,
                              option2,
                              option3,
                              option4
                            ]);
                          } else if (e.showId === 2 || e.showId === 4) {
                            tableList.push([
                              e.name,
                              e.typeName +
                                " " +
                                Number(e.target).toLocaleString(),
                              e.listData[5] === undefined
                                ? 0
                                : e.listData[5].value.toLocaleString(),
                              e.listData[4] === undefined
                                ? 0
                                : e.listData[4].value.toLocaleString(),
                              e.listData[3] === undefined
                                ? 0
                                : e.listData[3].value.toLocaleString(),
                              e.listData[2] === undefined
                                ? 0
                                : e.listData[2].value.toLocaleString(),
                              e.listData[1] === undefined
                                ? 0
                                : e.listData[1].value.toLocaleString(),
                              e.listData[0] === undefined
                                ? 0
                                : e.listData[0].value.toLocaleString(),
                              e.dataId,
                              option1,
                              option2,
                              option3,
                              option4
                            ]);
                          }
                        }
                      });
                    } else {
                      tableList.push([
                        result.data[0].name,
                        result.data[0].typeName + " " + result.data[0].target,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        result.data[0].dataId,
                        option1,
                        option2,
                        option3,
                        option4
                      ]);
                    }
                  }

                  axios(
                    "/api/v1/checkReport?group1=" +
                      option1 +
                      "&group2=" +
                      option2 +
                      "&group3=" +
                      option3 +
                      "&group4=" +
                      option4,
                    {
                      method: "GET"
                    }
                  )
                    .then(response => response.data)
                    .then(
                      result => {
                        var list = [];
                        if (
                          result.data.reportSub !== null &&
                          result.data.reportSub.length > 0
                        ) {
                          result.data.reportSub.forEach(e => {
                            list.push([e.dataId]);
                          });
                          setSelect(result.data.reportSub);
                        }
                      },
                      error => {
                        console.log(error);
                      }
                    );

                  setData(tableList);
                  var total = result.total / pageSize;
                  if (!Number.isInteger(total)) {
                    setTotalPages((total | 0) + 1);
                  } else if (total === 0) {
                    setTotalPages(1);
                  } else {
                    setTotalPages(total);
                  }
                },
                error => {
                  console.log(error);
                }
              );
          }
        },
        error => {
          alert(error);
        }
      );
  };

  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <Icon>
                  <AssignmentInd />
                </Icon>
              </CardIcon>
              <p className={classes2.cardCategory}>Welcome to</p>
              <h3 className={classes2.cardTitle}>
                ปีงบประมาณ <small>2563</small>
              </h3>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <TSSelect
                    zIndex={999}
                    options={l1OptionMain}
                    onChange={e => setOptionMain(e)}
                  />
                </GridItem>
              </GridContainer>
              <div style={{ paddingTop: "10px" }}></div>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <TSSelect
                    zIndex={998}
                    options={l2OptionB}
                    onChange={e => setOption2B(e)}
                    defaulfAdd={isCheck()}
                  />
                </GridItem>
              </GridContainer>
              <div style={{ paddingTop: "10px" }}></div>
              {(optionMain === 1 || optionMain === 4) && (
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <TSSelect
                      zIndex={997}
                      options={l3OptionB}
                      onChange={e => setOption3B(e)}
                      disabled={disable2B}
                      defaulfAdd={isCheck2B()}
                    />
                  </GridItem>
                </GridContainer>
              )}
              <div style={{ paddingTop: "10px" }}></div>
              {optionMain === 4 && (
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <TSSelect
                      zIndex={996}
                      options={l4OptionB}
                      onChange={e => setOption4B(e)}
                      disabled={disable3B}
                      defaulfAdd={isCheck3B()}
                    />
                  </GridItem>
                </GridContainer>
              )}
            </CardBody>
            <CardFooter chart style={{ textAlign: "center" }}>
              {isOpen && (
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <Button color="info" onClick={handleToggle}>
                      {!isOther && <h4>ข้อมูลอื่นๆ</h4>}
                      {isOther && <h4>ตัวชี้วัด</h4>}
                    </Button>
                  </GridItem>
                </GridContainer>
              )}
            </CardFooter>
          </Card>
        </GridItem>
        {isOpen && !isOther && (
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="primary" stats icon>
                <CardIcon color="primary">
                  <Icon>
                    <Subject />
                  </Icon>
                </CardIcon>
                <p className={classes2.cardCategory}>Welcome to</p>
                <h3 className={classes2.cardTitle}>
                  ปีงบประมาณ <small>2563</small>
                </h3>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <TSSelect
                      zIndex={999}
                      options={l1Option}
                      onChange={e => setOption1(e)}
                      defaulfAdd={isCheckMain()}
                    />
                  </GridItem>
                </GridContainer>
                <div style={{ paddingTop: "10px" }}></div>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <TSSelect
                      zIndex={998}
                      options={l2Option}
                      onChange={e => setOption2(e)}
                      disabled={disable1}
                      defaulfAdd={isCheck4()}
                    />
                  </GridItem>
                </GridContainer>
                <div style={{ paddingTop: "10px" }}></div>
                {(option1 === 1 || option1 === 4) && (
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <TSSelect
                        zIndex={997}
                        options={l3Option}
                        onChange={e => setOption3(e)}
                        disabled={disable2}
                        defaulfAdd={isCheck2()}
                      />
                    </GridItem>
                  </GridContainer>
                )}
                <div style={{ paddingTop: "10px" }}></div>
                {option1 === 4 && (
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <TSSelect
                        zIndex={996}
                        options={l4Option}
                        onChange={e => setOption4(e)}
                        disabled={disable3}
                        defaulfAdd={isCheck3()}
                      />
                    </GridItem>
                  </GridContainer>
                )}
                <div style={{ paddingTop: "10px" }}></div>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}></GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        )}
        {isOpen && !isOther && (
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="primary">
                <h4 className={classes.cardTitleWhite}>Simple Table</h4>
                <p className={classes.cardCategoryWhite}>
                  Here is a subtitle for this table
                </p>
              </CardHeader>
              <CardBody>
                <Table
                  tableHeaderColor="primary"
                  tableHead={tableHead}
                  tableData={data}
                  select={onSelected}
                  tableSelect={select}
                />
              </CardBody>
              <CardFooter style={{ textAlign: "center" }}>
                {/* <PaginationComponent
              totalItems={50}
              pageSize={10}
              onSelect={handleSelected}
            /> */}
                <Pagination
                  current={currentPage}
                  total={totalPages}
                  onPageChange={setCurrentPage}
                  maxWidth={windowWidth}
                />

                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <Button color="primary" onClick={handleSubmit}>
                      <h4>เพิ่ม</h4>
                    </Button>
                  </GridItem>
                </GridContainer>
              </CardFooter>
            </Card>
          </GridItem>
        )}

        {isOther && (
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="primary">
                <h4 className={classes.cardTitleWhite}>Simple Table</h4>
                <p className={classes.cardCategoryWhite}>
                  Here is a subtitle for this table
                </p>
              </CardHeader>
              <CardBody>
                <Table
                  tableHeaderColor="primary"
                  tableHead={tableHeadOther}
                  tableData={dataOther}
                  select={onSelected2}
                  tableSelect={select2}
                />
              </CardBody>
              <CardFooter style={{ textAlign: "center" }}>
                {/* <PaginationComponent
              totalItems={50}
              pageSize={10}
              onSelect={handleSelected}
            /> */}
                <Pagination
                  current={currentPage2}
                  total={totalPages}
                  onPageChange={setCurrentPage2}
                  maxWidth={windowWidth}
                />

                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <Button color="primary" onClick={handleSubmit}>
                      <h4>เพิ่ม</h4>
                    </Button>
                  </GridItem>
                </GridContainer>
              </CardFooter>
            </Card>
          </GridItem>
        )}
      </GridContainer>
      <GridContainer>
        {/* Confirm */}
        <Modal toggle={() => setModal(false)} isOpen={modal}>
          <div className="modal-header justify-content-center">
            <div>
              <i
                className={icon}
                style={{ color: "blue", fontSize: "2em" }}
              ></i>
            </div>
          </div>
          <ModalBody>
            <p
              style={{
                textAlign: "center"
              }}
            >
              {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                ? "ยืนยันการบันทึกข้อมูล"
                : "กำลังตรวจสอบข้อมูล"}
            </p>
            <p> </p>
          </ModalBody>
          <div className="modal-footer">
            <Button
              color="primary"
              type="button"
              onClick={() => setModal(false)}
            >
              <h4>ยกเลิก</h4>
            </Button>

            <Button
              color="primary"
              type="button"
              onClick={handleConfirm}
              disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
            >
              <h4>ยืนยัน</h4>
            </Button>
          </div>
        </Modal>
      </GridContainer>
    </div>
  );
}
